import { render, staticRenderFns } from "./company.form.vue?vue&type=template&id=3c079db0&scoped=true&"
import script from "./company.form.vue?vue&type=script&lang=js&"
export * from "./company.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c079db0",
  null
  
)

export default component.exports